export default __webpack_public_path__ + "static/media/img5.f0980922.webp";